


// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { useEffect, useState } from 'react';
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// // Components
// import NavbarComponent from './components/NavbarComponent';
// import Footer from './components/Footer';
// import Slider from './components/Slider';
// import Home from './components/Home';
// import Testimonials from './components/Testimonials';
// import StatsCounter from './components/StatsCounter';
// import FAQs from './components/FAQs';
// import ScrollToTop from './components/ScrollToTop';
// import WhatsAppPopup from './components/WhatsAppPopup';
// import VideoLoader from './components/VideoLoader';
// import UnderDevelopmentModal from './components/UnderDevelopmentModal';

// // Pages
// import AboutPage from './pages/AboutPage';
// import ContactPage from './pages/ContactPage';
// import DesktopSupport from './pages/DesktopSupport';
// import NetworkDesign from './pages/NetworkDesign';
// import TelecomSupport from './pages/TelecomSupport';
// import DataCenter from './pages/DataCenter';
// import WebAndApp from './pages/WebAndApp';
// import ManagedServices from './pages/ManagedServices';
// import CyberSecurity from './pages/CyberSecurity';
// import EndOfLifeHardwareSupport from './pages/HardwareSupport';

// import './App.css'; // Global styles
// import TopNavbar from './components/TopNavbar'; // Import the new TopNavbar component

// function App() {
//   const [showLoader, setShowLoader] = useState(false);

//   useEffect(() => {
//     AOS.init({ duration: 1000 });

//     const isFirstVisit = localStorage.getItem('visited');
//     const currentPath = window.location.pathname;

//     if (!isFirstVisit && currentPath === '/') {
//       setShowLoader(true);
//       localStorage.setItem('visited', 'true');
//     }
//   }, []);

//   if (showLoader) {
//     return <VideoLoader onFinish={() => setShowLoader(false)} />;
//   }

//   return (
//     <Router>
//           {/* <TopNavbar /> */}
//       <div className="d-flex flex-column min-vh-100">
//       {/* <TopNavbar /> */}
//         <NavbarComponent />
//         <div className="flex-grow-1">
//           <Routes>
//             {/* Landing/Home Page */}
//             <Route
//               path="/"
//               element={
//                 <>
//                   <Slider />
//                   <Home />
//                   <Testimonials />
//                   <StatsCounter />
//                 </>
//               }
//             />

//             {/* Main Pages */}
//             <Route path="/about" element={<AboutPage />} />
//             <Route path="/contact" element={<ContactPage />} />
//             <Route path="/faq" element={<FAQs />} />

//             {/* Service Pages */}
//             <Route path="/services/desktop-support" element={<DesktopSupport />} />
//             <Route path="/services/NetworkDesign" element={<NetworkDesign />} />
//             <Route path="/services/TelecomSupport" element={<TelecomSupport />} />
//             <Route path="/services/DataCenter" element={<DataCenter />} />
//             <Route path="/services/WebAndApp" element={<WebAndApp />} />
//             <Route path="/services/ManagedServices" element={<ManagedServices />} />
//             <Route path="/services/CyberSecurity" element={<CyberSecurity />} />
//             <Route path="/services/HardwareSupport" element={<EndOfLifeHardwareSupport />} />

//           </Routes>
//         </div>

//         {/* Global Components */}
//         <WhatsAppPopup />
//         <ScrollToTop />
//         <Footer />
//       </div>
//     </Router>
//   );
// }

// export default App;






















import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

// Components
import NavbarComponent from './components/NavbarComponent';
import Footer from './components/Footer';
import Slider from './components/Slider';
import Home from './components/Home';
import Testimonials from './components/Testimonials';
import StatsCounter from './components/StatsCounter';
import FAQs from './components/FAQs';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppPopup from './components/WhatsAppPopup';
// import VideoLoader from './components/VideoLoader'; // ❌ Commented out
import UnderDevelopmentModal from './components/UnderDevelopmentModal';
import DiwaliTopbar from './components/diwalitopbar';
// Pages
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DesktopSupport from './pages/DesktopSupport';
import NetworkDesign from './pages/NetworkDesign';
import TelecomSupport from './pages/TelecomSupport';
import DataCenter from './pages/DataCenter';
import WebAndApp from './pages/WebAndApp';
import ManagedServices from './pages/ManagedServices';
import CyberSecurity from './pages/CyberSecurity';
import EndOfLifeHardwareSupport from './pages/HardwareSupport';

import './App.css'; // Global styles
import TopNavbar from './components/TopNavbar'; // Import the new TopNavbar component

function App() {
  // const [showLoader, setShowLoader] = useState(false); // ❌ Commented out

  useEffect(() => {
    AOS.init({ duration: 1000 });

    // const isFirstVisit = localStorage.getItem('visited');
    // const currentPath = window.location.pathname;

    // if (!isFirstVisit && currentPath === '/') {
    //   setShowLoader(true);
    //   localStorage.setItem('visited', 'true');
    // }
  }, []);

  // if (showLoader) {
  //   return <VideoLoader onFinish={() => setShowLoader(false)} />; // ❌ Commented out
  // }

  return (
    <Router>
        {/* <DiwaliTopbar /> */}
      <div className="d-flex flex-column min-vh-100">
        {/* <TopNavbar /> */}
        <NavbarComponent />
        <div className="flex-grow-1">
          <Routes>
            {/* Landing/Home Page */}
            <Route
              path="/"
              element={
                <>
                  <Slider />
                  <Home />
                  <Testimonials />
                  <StatsCounter />
                </>
              }
            />

            {/* Main Pages */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/faq" element={<FAQs />} />

            {/* Service Pages */}
            <Route path="/services/desktop-support" element={<DesktopSupport />} />
            <Route path="/services/NetworkDesign" element={<NetworkDesign />} />
            <Route path="/services/TelecomSupport" element={<TelecomSupport />} />
            <Route path="/services/DataCenter" element={<DataCenter />} />
            <Route path="/services/WebAndApp" element={<WebAndApp />} />
            <Route path="/services/ManagedServices" element={<ManagedServices />} />
            <Route path="/services/CyberSecurity" element={<CyberSecurity />} />
            <Route path="/services/HardwareSupport" element={<EndOfLifeHardwareSupport />} />
          </Routes>
        </div>

        {/* Global Components */}
        <WhatsAppPopup />
        <ScrollToTop />
        <Footer />
      </div>
    </Router>
  );
}

export default App;

